import {ProductNutritionElementSign} from '../enums/product-nutrition-element-sign.enum';

export const productNutritionElementSigns = new Map<string, ProductNutritionElementSign>([
  ['<', ProductNutritionElementSign.LESS],
  ['=', ProductNutritionElementSign.EQUAL],
  ['>', ProductNutritionElementSign.MORE],
]);
